import React from "react"
import {
  FullwidthCTAContainer,
  BackgroundImgWrapper,
  BackgroundImg,
  InnerWrapper,
  TitleWrapper,
  TextWrapper,
  OuterTextWrapper,
} from "./style"
import { useStaticQuery, graphql } from "gatsby"
import { ReactComponent as ArrowRight } from "images/icons/arrow-right-with-circle.svg"
import { MainColumn } from "components/MainColumn"
import AvenueLink from "components/AvenueLink"

const FullwidthCTA = () => {
  const data = useStaticQuery(
    graphql`
      query {
        bgImage: file(relativePath: { eq: "full-width-cta-image.png" }) {
          childImageSharp {
            fluid(maxWidth: 2560, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `
  )

  const img = data.bgImage.childImageSharp.fluid

  return (
    <FullwidthCTAContainer>
      <BackgroundImgWrapper>
        <BackgroundImg fluid={img} />
        <InnerWrapper>
          <TitleWrapper>
            <h5>An Insider's Guide</h5>
            <h2>Moving To Canberra</h2>
          </TitleWrapper>
          <TextWrapper>
            <p>
              With a title like ‘world’s most liveable city’, it’s easy to see
              why so many people are making the move to Canberra.
            </p>

            <AvenueLink to="/"><ArrowRight /></AvenueLink>
          </TextWrapper>
        </InnerWrapper>
      </BackgroundImgWrapper>
      <MainColumn>
        <OuterTextWrapper>
          <p>
            With a title like ‘world’s most liveable city’, it’s easy to see why
            so many people are making the move to Canberra.
          </p>

          <AvenueLink to="/"><ArrowRight /></AvenueLink>
        </OuterTextWrapper>
      </MainColumn>
    </FullwidthCTAContainer>
  )
}

export default FullwidthCTA
